import { useState } from 'react';
import { AccountUser, TimezoneRequest } from 'vopay';
import apiConfig from '@/services/api.config';

const { api } = apiConfig;

export default function useAccountUsers() {
  const [loading, setLoading] = useState(false);
  const [users, setUsers] = useState<AccountUser[]>([]);

  async function fetchUsers(params: TimezoneRequest, accountToken?: string) {
    try {
      setLoading(true);
      const res = await api.fetchAccountUsers(params, accountToken);
      setUsers(res.Users);
    } finally {
      setLoading(false);
    }
  }

  return {
    loading,
    users,
    fetchUsers,
  };
}
